import React, { useContext, useState } from 'react'
import _ from 'lodash'

import { EntityPreviewCard, IEntityPreviewCardProps } from 'browser/components/atomic-elements/organisms/entity/entity-preview-card/entity-preview-card'

export const MobileEntityPreviewCard = (props: IEntityPreviewCardProps) => {

  return <EntityPreviewCard
    {...props}
    onClick={null}
    openOverlay={null}
    entitySheetMode={null}
    isClickable={false}
    style={{
      border: 0
    }}
  />

}
